import useSWR from 'swr'

import { ErrorState } from '@/components/ErrorState'
import { Loading } from '@/components/Loading'
import { Signature } from '@/containers/Settings/Signature/Signature'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { Settings } from '@/interfaces/Settings'

export default function SettingsSignaturePage() {
  const { data: settings, isLoading, error, mutate } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  return (
    <SettingsPage
      title="Razítko nebo podpis"
      description="Obrázek se vloží pod každý doklad. Nahrajte sken razítka nebo podpisu."
      breadcrumbHref="/settings/signature"
    >
      {isLoading && <Loading />}

      {error && <ErrorState>Nastala chyba při načítání nastavení.</ErrorState>}

      {!isLoading && !error && (
        <Signature signature={settings?.signature ?? null} onUploadSuccess={() => mutate()} />
      )}
    </SettingsPage>
  )
}
